import { environmentData } from '../../utils/baseInfo';
export function useUrl() {
  return {
    online_repair: '/onlineRepair', // 在线报修
    service_network: 'https://www.segway.com/service-locations/', // 服务网点
    after_sales_policy:
      'https://support.segway.com/service/after-sale-service-policies', // 售后政策
    dealer_service_request: '/dealerService', //经销商服务申请
    download_center: 'https://support.segway.com/', // 下载中心
    warranty_policy_query: 'https://support.segway.com/service/warranty', // 报修政策查询,
    buy_it: 'https://store.segway.com/new_parts', // 自助维修去购买
    dealer_service_iframe:
      'https://dms-portal-us.segway-ninebot.com:18050/dealerreturn/index.html#/',
    recall_iframe: 'https://www.surveymonkey.com/r/67QSKGK',

    /**导航菜单跳转地址 */
    logo: 'https://www.segway.com/',
    Consumer: 'https://www.segway.com/consumers',
    Professional: 'https://www.segway.com/professionals',
    Solutions: 'https://b2b.segway.com/',
    PowerSports: 'https://powersports.segway.com',
    Robotics: 'https://robotics.segway.com/',
    RoboticMower: 'https://navimow.segway.com/',
    CubeSeries: 'https://cubeseries.segway.com/',
    Support: '',
    SegwayRobotics: 'https://www.segwayrobotics.com/#/index',
    NineBotApp: 'https://www.ninebot.com/app/',
    NineBotSupport: 'https://support.ninebot.com/',
    ServiceNetworkPC:
      'https://transfer.ninebot.com/serviceSupport/serviceNetwork', // 服务网点
    ServiceNetworkM:
      'https://api5-h5-app-bj.ninebot.com/appservice/#/nearby-stores?hideBack=true', // 服务网点
    NinebotAccessoriesPrice:
      'https://transfer.ninebot.com/serviceSupport/accessoriesPrice',
    //'https://www.ninebot.com/serviceSupport/accessoriesPrice', // 配件价格
    NinebotCard: 'https://www.ninebot.cn/card/', // 礼品卡
    NinebotMailRepair: '/mailRepair', // 寄修服务
    icpUrl: 'https://beian.miit.gov.cn/',
    serviceCenter: '/serviceCenter',

    selfServiceRepairVideo: 'https://z.ninebot.com/url/743',
    serviceNetwork: '/serviceNetwork',
    accessoryPrices: '/accessoryPrices',
    recorderUrl:
      'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032458',
    ninebotUrl: 'https://www.ninebot.com/',
    ninebotSegwayUrl: 'https://www.ninebot.com/segway.html',
    storeSegwayUrl: 'https://store.segway.com/',
    snUrl: 'https://z.ninebot.com/url/802',
    vinUrl: 'https://z.ninebot.com/url/803',
    apSegwayUrl: 'https://ap-en.segway.com/',
    auSegwayUrl: 'https://au.segway.com/',
    trSegwayUrl: 'https://turkey.segway.com/',
    ruSegwayUrl: 'https://ru.segway.com/',
    ...urlConfig(environmentData.country)
  };
}

function urlConfig(country: string) {
  const config: any = {
    cn: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/website/support/m-index.png',
      segwayStore: 'https://jiuhaodiandong.jd.com/', // 配置跳转到京东旗舰店
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/support/img_ninebot_store.png', // 商城背景图
      onlineServer:
        'https://segway-ninebot.s4.udesk.cn/im_client/?web_plugin_id=15075', //在线客服
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/support/img_online_service.png' // 在线客服背景图
    },
    us: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore: 'https://store.segway.com/new_parts', // 九号商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServer:
        'https://dms-cc-us.segway-ninebot.com/chat_core/chatpage.html', //在线客服
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      segwayUrl: 'https://www.segway.com/'
    },
    eu: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore: 'https://segway.sparepartservice.shop/', // 九号商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServer:
        'https://europe.thrio.io/survey/?tenant=transcosmoseu&campaignId=672bc2e6a584c14308bb3b6d', //在线客服
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineRepair:
        'https://eu-en.segway.com/aftersales-for-consumer-electronics',
      segwayUrl: 'https://www.segway.com/'
    },
    de: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore: 'https://segway.sparepartservice.shop/', // 商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServer:
        'https://europe.thrio.io/survey/?tenant=transcosmoseu&campaignId=672a924aa584c14308bb3b64', //在线客服
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineRepair: 'https://de-de.segway.com/after-sales-service',
      segwayUrl: 'https://www.segway.com/'
    },
    it: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore: 'https://segway.sparepartservice.shop/', // 商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServer:
        'https://europe.thrio.io/survey/?tenant=transcosmoseu&campaignId=672a925d2be0e93ac14fb937', //在线客服
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineRepair:
        'https://it-it.segway.com/aftersales-service-for-consumer-electronics',
      segwayUrl: 'https://www.segway.com/'
    },
    es: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore: 'https://segway.sparepartservice.shop/', // 商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServer:
        'https://europe.thrio.io/survey/?tenant=transcosmoseu&campaignId=672a926a2be0e93ac14fb938', //在线客服
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineRepair: 'https://es-es.segway.com/after-sales-service',
      segwayUrl: 'https://www.segway.com/'
    },
    uk: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore: 'https://segway.sparepartservice.shop/', // 商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServer:
        'https://europe.thrio.io/survey/?tenant=transcosmoseu&campaignId=672a20ce2be0e93ac14fb931', //在线客服
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineRepair:
        'https://uk-en.segway.com/aftersales-service-for-consumer-electronics',
      segwayUrl: 'https://www.segway.com/'
    },
    fr: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore: 'https://segway.sparepartservice.shop/', // 商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServer:
        'https://europe.thrio.io/survey/?tenant=transcosmoseu&campaignId=672a20d38b4d063f87c4d62c', //在线客服
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineRepair:
        'https://fr-fr.segway.com/aftersales-service-for-consumer-electronics',
      segwayUrl: 'https://www.segway.com/'
    },
    ap: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineServer: 'https://ap-en.segway.com/contact.html', //在线客服
      segwayUrl: 'https://ap-en.segway.com/'
    },
    au: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore: 'https://www.segway.com.au/', // 商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineServer: 'https://au.segway.com/contact.html', //在线客服
      segwayUrl: 'https://au.segway.com/'
    },
    tr: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore:
        'https://www.aliexpress.com/store/1102714258/pages/all-items.html?spm=a2g0o.store_pc_home.pcShopHead_2004977948090.1&shop_sortType=bestmatch_sort', // 商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      onlineServer: 'https://turkey.segway.com/contact.html', //在线客服
      segwayUrl: 'https://turkey.segway.com/'
    },
    ru: {
      mobile_main:
        'https://oms-oss-public.ninebot.com/self-service/pch5/m-index.png', //手机端主图
      segwayStore:
        'https://www.aliexpress.com/store/1102714258/pages/all-items.html?spm=a2g0o.store_pc_home.pcShopHead_2004977948090.1&shop_sortType=bestmatch_sort', // 商城
      segwayStoreImg:
        'https://oms-oss-public.ninebot.com/website/img_segway_store.png', // 商城背景图
      onlineServerImg:
        'https://oms-oss-public.ninebot.com/website/img_online_service.png', // 在线客服背景图
      segwayUrl: 'https://ru.segway.com/'
    }
  };
  return config[country];
}
